module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAALdJREFUKJHVUcENgzAQ8yWL9HMoW5BO0lEok5FuEWAW4n44KS3Q0mctRUruzj7LAf4SctRomqYDAJIRAOZ5vp5SVNUhhBBrIRM7Rd5xwvea2yOLSKzfIYRIMp0iA7jX1ksprfe+3yw5IENVB3NAMu0FtiHXwUzT1JvtZVk6EUlW2+Bbqqo61H0x5VJKKyJxHMfD/1znbiQv3vv+xXalel8PnHMPs0wyWnA553QYmG2ye845fZr9GU9xNVEMvhfMLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sendtoux.png
// module id = v0B7
// module chunks = 1